<template>
    <div class="columns">
        <image-gallery :bid="bid"></image-gallery>
        <div v-if="isMobile" class="column is-10">
            <strong style="padding-right: 5px;">{{ bid.auction_name }}</strong>
            <strong style="padding-right: 5px;">@{{ bid.lot_date }}</strong>
        </div>
        <div class="column is-10" :class="{ 'padding-zero': !isMobile}">
            <table>
                <thead>
                <tr>
                    <th scope="col">LOT#:</th>
                    <th scope="col">Type:</th>
                    <th scope="col">Grade:</th>
                    <th scope="col">Km's:</th>
                    <th scope="col">Year:</th>
                    <th scope="col">Color:</th>
                    <th scope="col">CC:</th>
                    <th scope="col">Shift:</th>
                    <th scope="col">Start:</th>
                    <th v-if="bid.bids.length > 0" scope="col">Status:</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td data-label="Lot#">{{ bid.bid }}</td>
                    <td data-label="Type:">{{ bid.model_type }}</td>
                    <td data-label="Grade:"> <span v-html="bid.grade_en"></span></td>
                    <td data-label="Km's:">{{ bid.mileage * 1000 | formatNumber}}</td>
                    <td data-label="Year:">{{ bid.model_year }}</td>
                    <td data-label="Color:">{{ bid.color }}</td>
                    <td data-label="CC:">{{ bid.displacement }}</td>
                    <td data-label="Transmission:">{{ bid.transmission }}</td>
                    <td data-label="Start:">{{ bid.start_price_en * 1000 | formatNumber }}</td>
                    <td v-if="bid.bids.length > 0" data-label="Status:">
                        <span style="font-size: 9px!important;" v-for="b in bid.bids" :class="statusLabels[b.status].tagClass">{{ statusLabels[b.status].label }}</span>
                    </td>
                </tr>
                </tbody>
            </table>
            <lot-buttons v-if="bidIsOpen(bid.lot_date)" :bid="bid"></lot-buttons>
            <div class="field is-horizontal" :class="getClass" style="" v-else-if="bid.bids.length > 0">
                <button class="button is-small" disabled>Group: {{ bid.bids[0].group.name }} Max wins: {{ bid.bids[0].group.max_wins }} Position: {{ bid.bids[0].position }}</button>
                <router-link :to="'/single/' + bid.lot_id" class="button  is-small" target="_blank"><i class="fas fa-info-circle"></i></router-link>
            </div>
            <div class="field is-horizontal" :class="getClass" v-else>
                <button class="button is-small" disabled>All bids are closed</button>
                <router-link :to="'/single/' + bid.lot_id" class="button  is-small" target="_blank"><i class="fas fa-info-circle"></i></router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import lotButtons from './../Buttons/Lots/LotButtons.vue'
    import Gallery from './../Gallery/Gallery.vue'
    import moment from 'moment-timezone'
    export default {
        components: {
            lotButtons: lotButtons,
            imageGallery: Gallery
        },
        props: ['bid'],
        data() {
            return {
                time: null,
                statusLabels: [
                    {
                        tagClass: 'tag is-danger',
                        label: 'Canceled'
                    },
                    {
                        tagClass: 'tag is-link',
                        label: 'Active'
                    },
                    {
                        tagClass: 'tag is-success',
                        label: 'Win'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose to other'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Unsold'
                    },
                    {
                        tagClass: 'tag is-info',
                        label: 'Negotiations'
                    },
                ],
            }
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isMobile() {
                return document.documentElement.clientWidth < 450;
            },
            getClass() {
                if (document.documentElement.clientWidth < 450) {
                    return 'mobile-form'
                } else {
                    return 'descktop-form'
                }
            }
        },
        methods: {
            bidIsOpen(lot_date){

                return true

            }
        }
    }
</script>

<style scoped>
    .mobile-form {

    }
    .descktop-form {
        float: right;
        padding-top: 5px;
    }
    .padding-zero {
        padding-left: 0px;
    }
    table {
        border: 1px solid #ccc;
        border-collapse: collapse;
        margin: 0;
        padding: 0;
        width: 100%;
        table-layout: fixed;
    }

    table caption {
        font-size: 1.5em;
        margin: .5em 0 .75em;
    }

    table tr {
        background-color: #f8f8f8;
        border: 1px solid #ddd;
        padding: .35em;
    }

    table th,
    table td {
        padding: .625em;
        text-align: center;
        font-size: .65em;
    }

    table th {
        font-size: .65em;
        letter-spacing: .1em;
        text-transform: uppercase;
        background-color: #363636;
        color:white;
    }

    @media screen and (max-width: 600px) {
        table {
            border: 0;
        }

        table caption {
            font-size: 1.3em;
        }

        table thead {
            border: none;
            clip: rect(0 0 0 0);
            height: 1px;
            margin: -1px;
            overflow: hidden;
            padding: 0;
            position: absolute;
            width: 1px;
        }

        table tr {
            border-bottom: 3px solid #ddd;
            display: block;
            margin-bottom: .625em;
        }

        table td {
            border-bottom: 1px solid #ddd;
            display: block;
            font-size: .8em;
            text-align: right;
        }

        table td::before {
            content: attr(data-label);
            float: left;
            font-weight: bold;
            text-transform: uppercase;
        }

        table td:last-child {
            border-bottom: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Card/Content/LotContent.vue